import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductOpenIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M17.5 7.25H16.7206C16.4655 3.8309 14.4842 1.25 12 1.25C9.5158 1.25 7.5344 3.8309 7.2794 7.25H6.5C4.9834 7.25 3.75 8.4834 3.75 10V16C3.75 19.7217 6.7778 22.75 10.5 22.75H13.5C17.2217 22.75 20.25 19.7217 20.25 16V10C20.25 8.4834 19.0166 7.25 17.5 7.25ZM12 2.75C13.6033 2.75 14.9669 4.7468 15.2015 7.25H8.7984C9.0331 4.7468 10.3967 2.75 12 2.75ZM18.75 16C18.75 18.8945 16.3945 21.25 13.5 21.25H10.5C7.605 21.25 5.25 18.8945 5.25 16V12.5261C6.3181 13.5519 8.2951 14.5 12 14.5C13.7947 14.5 15.1702 14.2711 16.25 13.9253V16.5C16.25 16.9141 16.5859 17.25 17 17.25C17.4141 17.25 17.75 16.9141 17.75 16.5V13.2676C18.1481 13.0335 18.4813 12.7841 18.75 12.5261V16ZM17.7086 13.2947C17.7113 13.2931 17.7133 13.2915 17.716 13.2899C17.7135 13.3005 17.7111 13.3031 17.7086 13.2947ZM18.75 10.8807C18.2415 11.9204 16.697 13.5 12 13.5C7.303 13.5 5.7585 11.9204 5.25 10.8807V10C5.25 9.3105 5.8105 8.75 6.5 8.75H17.5C18.1895 8.75 18.75 9.3105 18.75 10V10.8807Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductOpenIcon.displayName = 'ProductOpenIcon';
